//import "./About.css";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../Services/AppInsightService";

interface IProps {
}

const About: React.FC<IProps> = (charProps) => {
 
    return (
        <div>
            The About Page.
        </div>
    );
}

export default withAITracking(reactPlugin, About);
